module.exports = __webpack_public_path__ + "media/about/cta-8703315e.jpg";